import { render, staticRenderFns } from "./VersendungMainPage.vue?vue&type=template&id=c1028b58"
import script from "./VersendungMainPage.vue?vue&type=script&lang=js"
export * from "./VersendungMainPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports